module.exports = __webpack_public_path__ + "files/mcsa-web-applications.9f0c2102.pdf";